import axios from './axios'

export const submitSupport = (token, categories, comment, organizationId = null) => {
	const payload = {
		categories,
		comment,
	};

	// Include organization ID if provided (for organization-specific support)
	if (organizationId) {
		payload.organization_id = organizationId;
	}

	return axios.post('/submit-support', payload, {
		headers: {
			"API-TOKEN": token,
		}
	})
}
